import styled from "styled-components";

import { FaRegTrashCan } from "react-icons/fa6";
import { useEffect, useMemo, useState } from "react";
import { formatBRLFromCents, parseCentsFromInput } from "../../../Funcoes/Money";
import useApi from "../../../hooks/useApi";
import { useLocation, useParams } from "react-router-dom";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";
import { useToast } from "../../../contexts/ToastContext";

const Container = styled.div`
    width: 100%;
    flex: 1;
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`
const Header = styled.div`
    width: 100%;
    height: 120px;
    display: flex;
    gap: 10px;
    background-color: #fff;
    margin-bottom: 15px;
    border-radius: 15px;
    padding: 15px;
    box-sizing: border-box;
`
const InfoWrapper = styled.div`
    width: 250px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    background-color: #f0f0f0;
    border-radius: 15px;
    p{
        font-size: 20px;
        font-weight: bold;
        margin: 0;
        margin-left: 20px;
    }
    h3 {
        font-size: 12px;
        color: #555;
        margin: 0;
        margin-left: 20px;
    }
`
const TabelaWrapper = styled.div`
    width: 100%;
    flex: 1;
    background-color: #fff;
    border-radius: 15px;
    overflow: auto;
`
const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    color: #333;
    thead {
        background-color: #f0f0f0;
        position: sticky;
        top: 0;
        z-index: 2;
    }
    tbody {
        tr {
            border-bottom: 1px solid #ccc;
            height: 45px;
            font-size: 14px;
            padding: 0 15px;
            &:nth-child(even) {
                background-color: #fafafa;
            }
            &:hover {
                background-color: #e0f7fa;
            }
        }
    }
`
const LinhaCabecalho = styled.tr`
    height: 45px;
    border-bottom: 2px solid #ccc;
`
const ColunaCabecalho = styled.th`
    width: ${props => props.width || "auto"};
    text-align: left;
    padding: 0 15px;
    color: #242d34;
    font-size: 15px;
`
const TdInput = styled.td`
    padding: 0;
`
const CellInput = styled.input`
    background-color: transparent;
    width: 100%;
    height: 40px;
    border: 1px solid #ccc;
    font-size: 14px;
    box-sizing: border-box;
    padding: 0 15px;
    &:focus {
        outline: none;
        border: 1px solid #007bff;
        border-color: #007bff;
        box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
    }
    //remover icone de input type date
    &[type="date"]::-webkit-calendar-picker-indicator {
        display: none;
    }
    &[disabled] {
        background-color: transparent;
        border: 1px solid transparent;
    }
`
const ActionWrapper = styled.div`
    width: 100%;
    display: flex;
    gap: 15px;
    margin-top: 15px;
`
const ActionButton = styled.button`
    padding: 10px 20px;
    background-color: ${props => props.disabled ? "#ccc" : "#007bff"};
    color: white;
    font-weight: bold;
    font-size: 14px;
    border: none;
    border-radius: 12px;
    cursor: ${props => props.disabled ? "auto" : "pointer"};
    margin: 0;
    &:hover{
        background-color: ${props => props.disabled ? "#ccc" : "#015fa3"};
    }
    transition: .3s;
`
const AddButton = styled.button`
    padding: 10px 20px;
    background-color: #28a745;
    color: white;
    font-weight: bold;
    font-size: 14px;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    margin: 0;
    &:hover{
        background-color: #218838;
    }
    transition: .3s;
    align-self: flex-start;
    margin-right: auto;
`
const EditButton = styled.button`
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    font-weight: bold;
    font-size: 12px;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    margin: 0;
    &:hover{
        background-color: #015fa3;
    }
    transition: .3s;
    &:disabled {
        background-color: #ccc;
        cursor: auto;
    }
`
const IconeWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
`
const Lixeira = styled(FaRegTrashCan)`
    width: 100%;
    height: 100%;
    color: #c0392b;
    cursor: pointer;
    &:hover {
        color: #e74c3c;
        transform: scale(1.1);
    }
    transition: .3s;
`
const LoadingWrapper = styled.div`
    width: 100%;
    height: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
const LoadingContainer = styled.div`
    width: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
const BMPendingWarning = styled.div`
    width: 250px;
    height: 100px;
    background-color: #fff3cd;
    position: absolute;
    bottom: 20px;
    left: 20px;
`

const BodyWrapper = () => {

    const { id } = useParams();
    const { notifySuccess, notifyError } = useToast();

    const api = useApi();

    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [boletins, setBoletins] = useState([]);
    const [originalBoletins, setOriginalBoletins] = useState([]);

    const [numPedido, setNumPedido] = useState("");
    const [valorFaturamento, setValorFaturamento] = useState(0);

    const handleFetchData = async () => {

        setLoading(true);

        try {

            const { data } = await api.get(`/Painel/API/ControleMedicao/GetPrevisaoBoletim/index.php?id=${id}`);

            console.log(data);

            setNumPedido(data.numPedido);
            setValorFaturamento(data.valorFaturamento);

            setBoletins(data.previsaoBoletim);
            setOriginalBoletins(data.previsaoBoletim);

        } catch (error) {
            console.error("Erro ao buscar dados:", error);
        } finally {
            setLoading(false);
        }

    }

    const { state } = useLocation();
    const [ isBMPending, setIsBMPending ] = useState(false);

    useEffect(() => {
        handleFetchData().then(() => {

            if( state && state.pendingBM ){

                setIsEditing(true);
                setIsBMPending(true);

            }

        })

    }, [])

    const handleAddBoletim = () => {

        handleStartEditing();

        const newBoletim = {
            id: null,
            idTemp: crypto.randomUUID(),
            numBoletim: "",
            data: "",
            valor_medicao: 0
        }

        setBoletins(prev => [...prev, newBoletim]);

    }

    const handleChange = (e, id) => {

        const { name, value } = e.target;

        setBoletins(prev => prev.map(item => {

            if (item.id === id || item.idTemp === id) {

                let valor = value;

                if (name === "valor_medicao") {

                    valor = parseCentsFromInput(value);

                }

                return {
                    ...item,
                    [name]: valor
                }
            }

            return item;

        }));

    }

    const isDirty = useMemo(() => {

        return JSON.stringify(boletins) !== JSON.stringify(originalBoletins);

    }, [boletins, originalBoletins]);

    const canSave = useMemo(() => {

        // verificar se a soma dos valores de medição é igual ao valor de faturamento do pedido de compra

        const somaMedicao = boletins.reduce((acc, item) => acc + item.valor_medicao, 0);
        return somaMedicao === valorFaturamento;

    }, [boletins, valorFaturamento]);

    const saldoPrevisao = useMemo(() => {

        return valorFaturamento - boletins.reduce((acc, item) => acc + item.valor_medicao, 0);

    }, [ boletins, valorFaturamento ]);

    const handleStartEditing = () => {

        setIsEditing(true);

    }

    const handleCancel = () => {

        if (!isDirty) {

            setIsEditing(false);
            return;

        }

        setBoletins(originalBoletins);
        setIsEditing(false);

    }

    const handleDelete = (id) => {

        // remover boletim da lista de boletins
        setBoletins(prev => prev.filter(item => item.id !== id && item.idTemp !== id));

    }

    const handleSave = async () => {

        // Enviar lista de boletins para a API para salvar no banco de dados

        try {

            setSaving(true);

            const formData = new FormData();

            formData.append("idPedido", id);
            formData.append("valorFaturamento", valorFaturamento);
            formData.append("boletins", JSON.stringify(boletins));

            const { data } = await api.post("/Painel/API/ControleMedicao/SavePrevisaoBoletim/", formData);
            console.log(data);

            notifySuccess("Previsão de boletim salva com sucesso!");

            setIsEditing(false);
            handleFetchData();

        } catch (e) {

            console.error(e);
            notifyError("Erro ao salvar previsão de boletim. Tente novamente.");

        } finally {

            setSaving(false);

        }

    }

    return (
        <Container>
            <Header>
                <InfoWrapper>
                    <p>{formatBRLFromCents(valorFaturamento)}</p>
                    <h3>VALOR DO PEDIDO</h3>
                </InfoWrapper>
                <InfoWrapper>
                    <p>R$ 0,00</p>
                    <h3>VALOR TOTAL DE BM</h3>
                </InfoWrapper>
                <InfoWrapper>
                    <p>{formatBRLFromCents(valorFaturamento)}</p>
                    <h3>VALOR A DISTRIBUIR NA PREVISÃO</h3>
                </InfoWrapper>
                <InfoWrapper>
                    <p>{formatBRLFromCents(saldoPrevisao)}</p>
                    <h3>SALDO PREVISÃO</h3>
                </InfoWrapper>
            </Header>
            <TabelaWrapper>
                {
                    loading ? (
                        <LoadingWrapper>
                            <LoadingContainer>
                                <SmallLoading />
                            </LoadingContainer>
                        </LoadingWrapper>
                    ) : (
                        <Tabela>
                            <thead>
                                <LinhaCabecalho>
                                    <ColunaCabecalho colSpan={3} >
                                        PREVISÃO DE FATURAMENTO PEDIDO DE COMPRA: {numPedido}
                                    </ColunaCabecalho>
                                    <ColunaCabecalho width="90px" >
                                        <EditButton
                                            onClick={handleStartEditing}
                                            disabled={isEditing}
                                        >
                                            {isEditing ? "EDITANDO" : "EDITAR"}
                                        </EditButton>
                                    </ColunaCabecalho>
                                </LinhaCabecalho>
                                <LinhaCabecalho>
                                    <ColunaCabecalho>Nº BM</ColunaCabecalho>
                                    <ColunaCabecalho>DATA</ColunaCabecalho>
                                    <ColunaCabecalho>VALOR DE MEDIÇÃO</ColunaCabecalho>
                                    <ColunaCabecalho />
                                </LinhaCabecalho>
                            </thead>
                            <tbody>
                                {
                                    boletins.map((item) => (
                                        <tr key={item.id || item.idTemp}>
                                            <td>
                                                <CellInput
                                                    type="text"
                                                    value={item.num_bm}
                                                    onChange={(e) => handleChange(e, item.id || item.idTemp)}
                                                    name="num_bm"
                                                    disabled={!isEditing}
                                                />
                                            </td>
                                            <td>
                                                <CellInput
                                                    type="date"
                                                    value={item.data}
                                                    onChange={(e) => handleChange(e, item.id || item.idTemp)}
                                                    name="data"
                                                    disabled={!isEditing}
                                                />
                                            </td>
                                            <TdInput>
                                                <CellInput
                                                    type="text"
                                                    value={formatBRLFromCents(item.valor_medicao)}
                                                    onChange={(e) => handleChange(e, item.id || item.idTemp)}
                                                    name="valor_medicao"
                                                    disabled={!isEditing}
                                                />
                                            </TdInput>
                                            <td>
                                                <IconeWrapper>
                                                    {
                                                        isEditing && (
                                                            <Lixeira
                                                                onClick={() => handleDelete(item.id || item.idTemp)}
                                                            />
                                                        )
                                                    }
                                                </IconeWrapper>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Tabela>
                    )
                }
            </TabelaWrapper>
            <ActionWrapper>
                <AddButton
                    onClick={handleAddBoletim}
                    disabled={saving}
                >
                    ACRESCENTAR PREVISÃO
                </AddButton>
                <ActionButton
                    // Botão de cancelar fica desabilitado se não estiver editando.
                    disabled={!isEditing || saving}
                    onClick={handleCancel}
                >CANCELAR</ActionButton>
                <ActionButton
                    disabled={!isDirty || !canSave || saving}
                    onClick={handleSave}
                >
                    {saving ? "SALVANDO..." : "SALVAR"}
                </ActionButton>
            </ActionWrapper>
            {
                isBMPending && (
                    <BMPendingWarning></BMPendingWarning>
                )
            }
        </Container>
    )
}

export default BodyWrapper;